import * as Api from '@ViewModels';
import { StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components-v2/Popover';
import { THEME } from '../../../components-v2/Theme/theme';
import { CalendarIcon } from '../../../components/svgs/icons/CalendarIcon';
import { getDueDate, IDueDateValue, isOverdue } from '../utils/buckets';
import { formatDueLabel } from '../utils/formatDue';
import { SnoozeMenu } from './SnoozeMenu';

interface IProps {
	item: Api.IActionItem;
	onChange: (value: IDueDateValue) => void;
	disabled?: boolean;
	size?: 'sm' | 'default';
}

export const DueChip: React.FC<IProps> = ({ item, onChange, disabled, size = 'sm' }) => {
	const [open, setOpen] = React.useState(false);
	const due = getDueDate(item);
	const overdue = isOverdue(item);
	const label = due ? formatDueLabel(due, !!item.hasDueTime) : 'Set date';
	const current: IDueDateValue = { dueDate: item.dueDate ?? null, hasDueTime: !!item.hasDueTime };

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant='ghost'
					size={size}
					disabled={disabled}
					aria-label={due ? `Due ${label}. Reschedule` : 'Set due date'}
					styles={[styleSheet.chip, overdue && styleSheet.overdue, !due && styleSheet.empty]}
					onClick={event => event.stopPropagation()}
				>
					<CalendarIcon width={14} height={14} />
					<span>{label}</span>
				</Button>
			</PopoverTrigger>
			<PopoverContent align='start' onClick={event => event.stopPropagation()}>
				<SnoozeMenu
					current={current}
					onSelect={value => {
						setOpen(false);
						onChange(value);
					}}
				/>
			</PopoverContent>
		</Popover>
	);
};

const styleSheet = StyleSheet.create({
	chip: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.standard,
		whiteSpace: 'nowrap',
	},
	overdue: {
		color: THEME.colors.danger.dark,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	empty: {
		opacity: 0.7,
	},
});
